import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'sns-bucket-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        issnsFolderOpen: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 'sns-bucket-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'sns-bucket-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'sns-bucket-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,

        // Resource Section
        awsAccount: null,
        topicName: null,
        displayName: null,
        topicType: 'Standard',
        messageRetentionPeriod: '30 Days',
        contentBasedDeduplication: 'Disabled',
        deliveryRetryPolicy: '3 Retries',
        subscriptions: [],
        savedSubscriptions: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'SNS costs are based on publish requests, delivery attempts, data transfer, and optional SMS/call charges. The free tier covers 1M publishes, 1M deliveries, and 1GB data transfer monthly.',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'sns-bucket-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'sns-bucket-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'sns-bucket-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'sns-bucket-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'sns-bucket-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'sns-bucket-isAppShortNameExist',
    default: false,
});
